<div class="company-onboarding__wrapper company-onboarding-success">
  <div class="company-onboarding__form-content">
    <div class="company-onboarding__step-info">
      <p class="company-onboarding__step-info__name">All set up!</p>
      <p class="company-onboarding__step-info__title">You have successfully set up the company.</p>
    </div>
    <div class="company-onboarding__form"></div>
  </div>
</div>
